import gql from 'graphql-tag';

const CHANGE_PASSWORD = gql`
    mutation passwordChange($oldPassword:String!, $newPassword:String!) {
        passwordChange(password: $oldPassword, newPassword: $newPassword )
    }
`;

export default CHANGE_PASSWORD;